export default __webpack_public_path__ + "static/media/icons-arrow-up.ae2171f2.svg";